import React from "react";
import { Box, Typography } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";

import { IMAGES } from "@APP/assets";
import { MOBILE_GUTTER } from "@APP/styles/mobile";

// The scrollable element is the PageLayout content container rather than the
// window; PageLayout tags it with this id.
export const PAGE_CONTENT_ID = "pageLayoutContent";

// Retained for API compatibility with callers that still pass a footer variant.
export type FooterVariant = "links" | "minimal";

interface Props {
  variant?: FooterVariant;
}

const useStyles = makeStyles((theme) => ({
  // Every screen ends with the same mark: the Lloyds horse over "Powered by
  // Lloyds", centred on the page background.
  bar: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: theme.spacing(0.75),
    // The mobile Figma spaces the mark 48px above and below (same as desktop).
    padding: `16px ${MOBILE_GUTTER}px`,
    backgroundColor: theme.palette.background.default,
  },
  logo: {
    // The mark sits directly on the page background — appLogo.svg carries no
    // backing plate, so nothing should be drawn behind it here.
    width: 56,
    height: 56,
    objectFit: "contain",
  },
  poweredBy: {
    // "Powered by Lloyds" sits in an 18px line box on mobile too (≈12px).
    fontSize: 12,
    lineHeight: 1,
  },
}));

const Footer: React.FC<Props> = () => {
  const styles = useStyles();

  return (
    <Box component="footer" className={styles.bar} id="pageFooterLinksBar">
      <img src={IMAGES.APP_LOGO} className={styles.logo} alt="" />
      <Typography component="span" className={styles.poweredBy} id="pageFooterPoweredBy">
        Powered by Lloyds
      </Typography>
    </Box>
  );
};

export default Footer;
